import React from "react";
import { useUser } from "../Contexts/UserContext";
import { Navigate } from "react-router-dom";
import Error from "../components/Error";

const ProtectedRoute = ({ children, role }) => {
  const { user } = useUser();

  if (!user) {
    return <Navigate to={"/ingresar"} replace />;
  }

  if (role === "admin" && user.role !== "admin") {
    return <Error />;
  }

  return children;
};

export default ProtectedRoute;
